import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import InformationBox from 'components/common/information-box'
import InformationBoxContent from 'components/common/information-box-content'
import InformationBoxHeader from 'components/common/information-box-header'
import { withI18next } from 'lib/i18n/withI18next'
import { locizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

const ModelInfo = ({ customClass, model, t }) => {
  const { height, bust, waist, hips, size } = model
  const [modelTitle, modelHeight, modelBody, modelSize] = locizeTranslation(t, {
    PDP__MODEL_INFO: 'Model Info',
    PDP__MODEL_HEIGHT: "Model's height is %d CM",
    PDP__MODEL_BODY: 'Bust / Waist / Hips %b - %w - %h',
    PDP__MODEL_WEARING_SIZE: 'Wearing a size %d in this item',
  })
  const formatModeHeight = modelHeight.replace('%d', height)
  const formatModelBody = modelBody
    .replace('%b', bust)
    .replace('%w', waist)
    .replace('%h', hips)
  const formatModelSize = modelSize.replace('%d', size)
  const hasModelBody = bust && waist && hips

  return (
    <InformationBox className={clsx('model-info', customClass)}>
      <style jsx>{styles}</style>
      <InformationBoxHeader title={modelTitle} />
      <InformationBoxContent>
        {height && <div>{formatModeHeight}</div>}
        {hasModelBody && <div>{formatModelBody}</div>}
        {size && <div>{formatModelSize}</div>}
      </InformationBoxContent>
    </InformationBox>
  )
}

ModelInfo.defaultProps = {
  customClass: '',
}

ModelInfo.propTypes = {
  customClass: PropTypes.string,
  model: PropTypes.shape({
    bust: PropTypes.number,
    height: PropTypes.number,
    hips: PropTypes.number,
    size: PropTypes.string,
    waist: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ModelInfo)
